import { useContext, useState } from "react";
import TableHeader from "./TableHeader";
import TableRow from "./TableRow";
import SummaryBar from "./SummaryBar";
import AddNew from "../common/AddNew";
import { downloadFile } from "../../utils/download";
import { AuthContext } from "../../context/AuthContext";


const Table = ({ data }) => {

  const { role } = useContext(AuthContext);
  const [selectedRows, setSelectedRows] = useState([]);

  const handleSelect = (id) => {
    if (selectedRows.includes(id)) {
      setSelectedRows(selectedRows.filter((rowId) => rowId !== id));
    } else {
      setSelectedRows([...selectedRows, id]);
    }
  };

  const handleSelectAll = () => {
    if (selectedRows.length === data.length) {
      setSelectedRows([]);
    } else {
      setSelectedRows(data.map((task) => task.id));
    }
  };

  const selectedTasks = data.filter((task) =>
    selectedRows.includes(task.id)
  );

  const totalFiles = selectedTasks.length;

  const totalWords = selectedTasks.reduce(
    (sum, task) => sum + task.words,
    0
  );

  const handleDownload = (taskid, target_file) => {
    downloadFile(taskid, target_file);
  };

  return (
    <div>
      <div className="flex flex-wrap justify-between items-center">
        {role === "admin" && <AddNew />}
        <SummaryBar
          totalFiles={totalFiles}
          totalWords={totalWords}
        />
      </div>
      {data.length > 0 ? (
        <div className="shadow-md">
          <table className="w-full border border-gray-300 border-collapse text-sm break-all">
            <TableHeader
              isAllSelected={data.length > 0 && selectedRows.length === data.length}
              onSelectAll={handleSelectAll}
            />
            <tbody>
              {data.map((task) => (
                <TableRow
                  key={task.id}
                  task={task}
                  isSelected={selectedRows.includes(task.id)}
                  onSelect={handleSelect}
                  handleDownload={handleDownload}
                />
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="overflow-x-auto shadow-md">
          <table className="w-full border border-gray-300 border-collapse text-sm bg-white">
            <tbody>
              <tr>
                <td className="text-center text-xl p-4 text-gray-900">
                  No Tasks Assigned.
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default Table;
